import { styled, css, Link } from '@mui/material';

import CaretDownIcon from '../../../icons/CaretDownIcon';

export const StyledNavMenuDesktop = styled('nav')(
  ({ theme }) => css`
    position: relative;
    height: 3rem;
    box-shadow: ${theme.shadows[2]};
    z-index: 50;
    background-color: ${theme.palette.common.white};
    display: none;

    ${theme.breakpoints.up('desktop')} {
      display: block;
    }
  `
);

export const StyledNavMenuDesktopContainer = styled('div')(
  ({ theme }) => css`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    column-gap: ${theme.spacing('LARGE')};
    margin: 0 auto;
    max-width: ${theme.shape.headerMaxWidth};
  `
);

export const StyledNavMenuItemDesktopLink = styled(Link)(
  ({ theme, isCurrentPage }) => css`
    align-items: center;
    color: ${isCurrentPage
      ? theme.palette.text.navMenuLinkHover
      : theme.palette.main.professional_blue};
    column-gap: ${theme.spacing('SMALL')};
    display: flex;
    text-decoration: none;
    pointer-events: ${isCurrentPage ? 'none' : 'auto'};

    &:hover {
      color: ${theme.palette.text.navMenuLinkHover};
    }

    &:active {
      text-decoration: underline;
    }

    &.Mui-focusVisible {
      text-decoration: underline;
    }

    &[aria-expanded='true'] {
      color: ${theme.palette.text.navMenuLinkHover};
      text-decoration: underline;
    }
  `
);

export const StyledNavLinkDropdownContainer = styled('div')`
  height: 100%;

  & > button {
    height: 100%;
  }
`;

export const StyledCaretIconContainer = styled('div')`
  align-items: center;
  display: flex;
  height: 1.5rem;
  justify-content: center;
  width: 1.5rem;
`;

export const StyledCaretIcon = styled(CaretDownIcon)(
  ({ theme, open }) => css`
    width: auto;
    height: auto;

    transition: transform 0.1s ease-out;

    ${open &&
    css`
      transform: translateY(2px) rotate(180deg);

      & > path {
        stroke: ${theme.palette.text.navMenuLinkHover};
      }
    `}
  `
);
